import request from '@/utils/request'

/**
 * 根据用户ID获取经销商列表（userid）
 * @param data
 * @returns {AxiosPromise}
 */
export function getErpDealerList(data) {
  return request({
    url: 'api/getErpDealerList',
    method: 'post',
    params: data
  })
}

/**
 * 获取原正单列表
 * @param data
 * @returns {AxiosPromise}
 */
export function getErpOldOrderList(data) {
  return request({
    url: 'api/getErpOldOrderList',
    method: 'post',
    params: data
  })
}

/**
 * 获取经销商代理品牌列表（delid）
 * @param data
 * @returns {AxiosPromise}
 */
export function getErpDealerBrandList(data) {
  return request({
    url: 'api/getErpDealerBrandList',
    method: 'post',
    params: data
  })
}

/**
 * 获取客供物料字典表的物料名称
 * @param data
 * @returns {AxiosPromise}
 */
export function getClientMaterial(data) {
  return request({
    url: 'api/getClientMaterial',
    method: 'post',
    params: data
  })
}

/**
 * 订单代录
 * @param data
 * @returns {AxiosPromise}
 */
export function ErpOrderReplace(data) {
  return request({
    url: 'api/ErpOrderReplace',
    method: 'post',
    params: data
  })
}

/**
 * 获取订单列表
 * @param data
 * @returns {AxiosPromise}
 */
export function getOrderList(data) {
  return request({
    url: 'api/getOrderList',
    method: 'post',
    params: data
  })
}

/**
 * 接单操作
 * @param data
 * @returns {AxiosPromise}
 */
export function acceptOrder(data) {
  return request({
    url: 'api/acceptOrder',
    method: 'post',
    params: data
  })
}

/**
 * 技术评估操作
 * @param data
 * @returns {AxiosPromise}
 */
export function assessOrder(data) {
  return request({
    url: 'api/assessOrder',
    method: 'post',
    params: data
  })
}

/**
 * 查看所有技术驳回订单
 * @param data
 * @returns {AxiosPromise}
 */
export function getOrderJsbh(data) {
  return request({
    url: 'api/getOrderJsbh',
    method: 'post',
    params: data
  })
}
/**
 * 查看技术驳回订单统计
 * @param data
 * @returns {AxiosPromise}
 */
export function getOrderJsbhAnalysis(data) {
  return request({
    url: 'api/getOrderJsbhAnalysis',
    method: 'post',
    params: data
  })
}
/**
 * 查看技术驳回订单统计详情
 * @param data
 * @returns {AxiosPromise}
 */
export function getOrderJsbhAnalysisDetail(data) {
  return request({
    url: 'api/getOrderJsbhAnalysisDetail',
    method: 'post',
    params: data
  })
}
/**
 * 导出所有技术驳回订单
 * @param data
 * @returns {AxiosPromise}
 */
export function exportOrderJsbh(data) {
  return request({
    url: 'api/exportOrderJsbh',
    method: 'post',
    params: data
  })
}

/**
 * 技术评估驳回原因
 * @param data
 * @returns {AxiosPromise}
 */
export function getBhRsonList(data) {
  return request({
    url: 'api/getBhRsonList',
    method: 'post',
    params: data
  })
}

/**
 * 拆单分配操作
 * @param data
 * @returns {AxiosPromise}
 */
export function splitOrder(data) {
  return request({
    url: 'api/splitOrder',
    method: 'post',
    params: data
  })
}

/**
 * 订单拆单料单导入
 * @param data
 * @returns {AxiosPromise}
 */
export function ErpOrderImportMaterial(data) {
  return request({
    url: 'api/ErpOrderImportMaterial',
    method: 'post',
    params: data
  })
}

/**
 * 获取订单料单详情
 * @param data
 * @returns {AxiosPromise}
 */
export function getErpOrderMaterialDetail(data) {
  return request({
    url: 'api/getErpOrderMaterialDetail',
    method: 'post',
    params: data
  })
}
export function getErpOrderMaterialDetailExport(data) {
  return request({
    url: 'api/getErpOrderMaterialDetailExport',
    method: 'post',
    params: data
  })
}

/**
 * 拆单完成操作
 * @param data
 * @returns {AxiosPromise}
 */
export function splitCarryOrder(data) {
  return request({
    url: 'api/splitCarryOrder',
    method: 'post',
    params: data
  })
}

/**
 * 订单确认操作
 * @param data
 * @returns {AxiosPromise}
 */
export function confirmOrder(data) {
  return request({
    url: 'api/confirmOrder',
    method: 'post',
    params: data
  })
}

/**
 * 订单报价单解析
 * @param data
 * @returns {AxiosPromise}
 */
export function ErpOrderImportOffer(data) {
  return request({
    url: 'api/ErpOrderImportOffer',
    method: 'post',
    params: data
  })
}

/**
 * 数字金额转大写金额
 * @param price
 * @returns {string}
 */
export function digitUppercase(price) {
  const fraction = ['角', '分']
  const digit = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖']
  const unit = [
    ['元', '万', '亿'],
    ['', '拾', '佰', '仟']
  ]
  let num = Math.abs(price)
  let s = ''
  fraction.forEach((item, index) => {
    s += (digit[Math.floor(num * 10 * (10 ** index)) % 10] + item).replace(/零./, '')
  })
  s = s || '整'
  num = Math.floor(num)
  for (let i = 0; i < unit[0].length && num > 0; i += 1) {
    let p = ''
    for (let j = 0; j < unit[1].length && num > 0; j += 1) {
      p = digit[num % 10] + unit[1][j] + p
      num = Math.floor(num / 10)
    }
    s = p.replace(/(零.)*零$/, '').replace(/^$/, '零') + unit[0][i] + s
  }
  return s.replace(/(零.)*零元/, '元').replace(/(零.)+/g, '零').replace(/^整$/, '零元整')
}

/**
 * 订单报价操作
 * @param data
 * @returns {AxiosPromise}
 */
export function offerOrder(data) {
  return request({
    url: 'api/offerOrder',
    method: 'post',
    params: data
  })
}

/**
 * 收款申请列表
 * @param data
 * @returns {AxiosPromise}
 */
export function getCollectionApplyList(data) {
  return request({
    url: 'api/getCollectionApplyList',
    method: 'post',
    params: data
  })
}

/**
 * 获取收款性质列表
 * @param data
 * @returns {AxiosPromise}
 */
export function getReceiptNature() {
  return request({
    url: 'api/getReceiptNature',
    method: 'post'
  })
}

/**
 * 添加收款页面信息
 * @param data
 * @returns {AxiosPromise}
 */
export function addCollectionInfo(data) {
  return request({
    url: 'api/addCollectionInfo',
    method: 'post',
    params: data
  })
}

/**
 * 添加收款页面信息2 -- 订单收款对账单中的对公打款详情使用
 * @param data
 * @returns {AxiosPromise}
 */
export function getCollectionInfo(data) {
  return request({
    url: 'api/getCollectionInfo',
    method: 'post',
    params: data
  })
}

/**
 * 添加或编辑收款申请
 * @param data
 * @returns {AxiosPromise}
 */
export function addOrEditCollectApply(data) {
  return request({
    url: 'api/addOrEditCollectApply',
    method: 'post',
    params: data
  })
}

/**
 * 删除打款申请
 * @param data
 * @returns {AxiosPromise}
 */
export function deleteCollect(data) {
  return request({
    url: 'api/deleteCollect',
    method: 'post',
    params: data
  })
}

/**
 * 收款审核操作
 * @param data
 * @returns {AxiosPromise}
 */
export function reviewReceipt(data) {
  return request({
    url: 'api/reviewReceipt',
    method: 'post',
    params: data
  })
}

/**
 * 添加或编辑样品预存款申请
 * @param data
 * @returns {AxiosPromise}
 */
export function addOrEditDealerJoinApply(data) {
  return request({
    url: 'api/addOrEditDealerJoinApply',
    method: 'post',
    params: data
  })
}

/**
 * 添加或编辑冲业绩收款申请
 * @param data
 * @returns {AxiosPromise}
 */
export function addOrEditAchievementApply(data) {
  return request({
    url: 'api/addOrEditAchievementApply',
    method: 'post',
    params: data
  })
}

/**
 * 添加或编辑其他收款申请
 * @param data
 * @returns {AxiosPromise}
 */
export function addOrEditOtherApply(data) {
  return request({
    url: 'api/addOrEditOtherApply',
    method: 'post',
    params: data
  })
}

/**
 * 获取样品预存款打款申请
 * @param data
 */
export function getDealerJoinApplyById(data) {
  return request({
    url: 'api/getDealerJoinApplyById',
    method: 'post',
    params: data
  })
}

/**
 * 样品预存款打款申请审核
 * @param data
 */
export function reviewDealerJoin(data) {
  return request({
    url: 'api/reviewDealerJoin',
    method: 'post',
    params: data
  })
}

/**
 * 获取订单报价信息
 * @param data
 * @returns {AxiosPromise}
 */
export function getErpOrderOfferDetail(data) {
  return request({
    url: 'api/getErpOrderOfferDetail',
    method: 'post',
    params: data
  })
}

/**
 * 获取扣款短信验证码
 * @param data
 * @returns {AxiosPromise}
 */
export function getDebitSMSCode(data) {
  return request({
    url: 'api/getDebitSMSCode',
    method: 'post',
    params: data
  })
}

/**
 * 预付款操作
 * @param data
 * @returns {AxiosPromise}
 */
export function insteadSubsist(data) {
  return request({
    url: 'api/insteadSubsist',
    method: 'post',
    params: data
  })
}

/**
 * 跳过预付款操作
 * @param data
 * @returns {AxiosPromise}
 */
export function passSubsist(data) {
  return request({
    url: 'api/passSubsist',
    method: 'post',
    params: data
  })
}

/**
 * 预付款驳回
 * @param data
 * @returns {AxiosPromise}
 */
export function insteadSubsistDown(data) {
  return request({
    url: 'api/insteadSubsistDown',
    method: 'post',
    params: data
  })
}

/**
 * 工厂分派及之后订单列表
 * @param data
 * @returns {AxiosPromise}
 */
export function getOrderProductList(data) {
  return request({
    url: 'api/getOrderProductList',
    method: 'post',
    params: data
  })
}

/**
 * 获取工厂列表
 * @param data
 * @returns {AxiosPromise}
 */
export function getFactoryList() {
  return request({
    url: 'api/getFactoryList',
    method: 'post'
  })
}

/**
 * 获取公司列表
 * @returns {AxiosPromise}
 */
export function getGroupReport() {
  return request({
    url: 'api/getGroupReport()',





    method: 'post'
  })
}

/**
 * 工厂分派操作
 * @param data
 * @returns {AxiosPromise}
 */
export function factoryAssign(data) {
  return request({
    url: 'api/factoryAssign',
    method: 'post',
    params: data
  })
}

/**
 * 多工厂分派操作
 * @param data
 * @returns {AxiosPromise}
 */
export function multiFactoryAssign(data) {
  return request({
    url: 'api/multiFactoryAssign',
    method: 'post',
    params: data
  })
}

/**
 * 工厂分派操作
 * @param data
 * @returns {AxiosPromise}
 */
export function undoFactoryAssign(data) {
  return request({
    url: 'api/undoFactoryAssign',
    method: 'post',
    params: data
  })
}

/**
 * 工厂分派操作
 * @param data
 * @returns {AxiosPromise}
 */
export function factoryOrders(data) {
  return request({
    url: 'api/factoryOrders',
    method: 'post',
    params: data
  })
}

/**
 * 工序列表
 * @param data
 * @returns {AxiosPromise}
 */
export function getProcessList(data) {
  return request({
    url: 'api/getProcessList',
    method: 'post',
    params: data
  })
}

/**
 * 订单排产操作
 * @param data
 * @returns {AxiosPromise}
 */
export function orderSchedule(data) {
  return request({
    url: 'api/orderSchedule',
    method: 'post',
    params: data
  })
}

/**
 * 获取分类打印信息
 * @param data
 * @returns {AxiosPromise}
 */
export function getErpOrderCategoryPrint(data) {
  return request({
    url: 'api/getErpOrderCategoryPrint',
    method: 'post',
    params: data
  })
}

/**
 * 生产订单分类打印页面
 * @param data
 * @returns {AxiosPromise}
 */
export function ErpOrderCategoryPrint(data) {
  return request({
    url: 'api/ErpOrderCategoryPrint',
    method: 'post',
    params: data
  })
}

/**
 * 获取部件条码详细信息
 * @param data
 * @returns {AxiosPromise}
 */
export function getErpOrderPartsDetail(data) {
  return request({
    url: 'api/getErpOrderPartsDetail',
    method: 'post',
    params: data
  })
}

/**
 * 获取订单部件条码列表
 * @param data
 * @returns {AxiosPromise}
 */
export function getErpOrderBarcodeList(data) {
  return request({
    url: 'api/getErpOrderBarcodeList',
    method: 'post',
    params: data
  })
}

/**
 * 获取配件详细信息
 * @param data
 * @returns {AxiosPromise}
 */
export function getErpOrderAccessoriesDetail(data) {
  return request({
    url: 'api/getErpOrderAccessoriesDetail',
    method: 'post',
    params: data
  })
}

/**
 * 获取订单配件列表
 * @param data
 * @returns {AxiosPromise}
 */
export function getErpOrderAccessoriesList(data) {
  return request({
    url: 'api/getErpOrderAccessoriesList',
    method: 'post',
    params: data
  })
}

/**
 * 配件打印页面
 * @param data
 * @returns {AxiosPromise}
 */
export function ErpOrderAccessoriesPrint(data) {
  return request({
    url: 'api/ErpOrderAccessoriesPrint',
    method: 'post',
    params: data
  })
}

/**
 * 木工全检列表
 * @param data
 * @returns {AxiosPromise}
 */
export function woodAllCheckList(data) {
  return request({
    url: 'api/woodAllCheckList',
    method: 'post',
    params: data
  })
}

/**
 * 木工全检详情
 * @param data
 * @returns {AxiosPromise}
 */
export function getWoodCheckDetail(data) {
  return request({
    url: 'api/getWoodCheckDetail',
    method: 'post',
    params: data
  })
}

/**
 * 木工全检提交
 * @param data
 * @returns {AxiosPromise}
 */
export function submitWoodCheck(data) {
  return request({
    url: 'api/submitWoodCheck',
    method: 'post',
    params: data
  })
}

/**
 * 油漆全检列表
 * @param data
 * @returns {AxiosPromise}
 */
export function paintAllCheckList(data) {
  return request({
    url: 'api/paintAllCheckList',
    method: 'post',
    params: data
  })
}

/**
 * 油漆全检详细
 * @param data
 * @returns {AxiosPromise}
 */
export function getPaintCheckDetail(data) {
  return request({
    url: 'api/getPaintCheckDetail',
    method: 'post',
    params: data
  })
}

/**
 * 油漆全检提交
 * @param data
 * @returns {AxiosPromise}
 */
export function submitPaintCheck(data) {
  return request({
    url: 'api/submitPaintCheck',
    method: 'post',
    params: data
  })
}

/**
 * 获取打包类型列表
 * @param data
 * @returns {AxiosPromise}
 */
export function getErpPacktypelist() {
  return request({
    url: 'api/getErpPacktypelist',
    method: 'post'
  })
}

/**
 * 获取员工用户当前组织信息
 * @param data
 * @returns {AxiosPromise}
 */
export function getGroupInfoByUser(data) {
  return request({
    url: 'api/getGroupInfoByUser',
    method: 'post',
    params: data
  })
}

/**
 * 根据条码查询部件信息
 * @param data
 * @returns {AxiosPromise}
 */
export function getUnitByBarcode(data) {
  return request({
    url: 'api/getUnitByBarcode',
    method: 'post',
    params: data
  })
}

/**
 * 部件打包操作
 * @param data
 * @returns {AxiosPromise}
 */
export function unpackUnit(data) {
  return request({
    url: 'api/unpackUnit',
    method: 'post',
    params: data
  })
}

/**
 * 获取打包列表
 * @param data
 * @returns {AxiosPromise}
 */
export function getErpPackList(data) {
  return request({
    url: 'api/getErpPackList',
    method: 'post',
    params: data
  })
}

/**
 * 获取订单包装列表
 * @param data
 * @returns {AxiosPromise}
 */
export function getErpOrderPackList(data) {
  return request({
    url: 'api/getErpOrderPackList',
    method: 'post',
    params: data
  })
}

/**
 * 包装补打
 * @param data
 * @returns {AxiosPromise}
 */
export function ErpPackReprint(data) {
  return request({
    url: 'api/ErpPackReprint',
    method: 'post',
    params: data
  })
}

/**
 * 订单拆包（整包拆除）
 * @param data
 * @returns {AxiosPromise}
 */
export function ErpOrderUnpack(data) {
  return request({
    url: 'api/ErpOrderUnpack',
    method: 'post',
    params: data
  })
}

/**
 * 获取订单包装部件列表
 * @param data
 * @returns {AxiosPromise}
 */
export function getErpOrderPackInfoList(data) {
  return request({
    url: 'api/getErpOrderPackInfoList',
    method: 'post',
    params: data
  })
}

/**
 * 订单拆包（部件拆除）
 * @param data
 * @returns {AxiosPromise}
 */
export function ErpOrderUnpackInfo(data) {
  return request({
    url: 'api/ErpOrderUnpackInfo',
    method: 'post',
    params: data
  })
}

/**
 * 获取订单拆包记录列表
 * @param data
 * @returns {AxiosPromise}
 */
export function getErpOrderUnpackRecordList(data) {
  return request({
    url: 'api/getErpOrderUnpackRecordList',
    method: 'post',
    params: data
  })
}

/**
 * 获取订单拆包记录部件列表
 * @param data
 * @returns {AxiosPromise}
 */
export function getErpOrderUnpackRecordInfoList(data) {
  return request({
    url: 'api/getErpOrderUnpackRecordInfoList',
    method: 'post',
    params: data
  })
}

/**
 * 获取包装列表（PC包装下拉控件）
 * @param data
 * @returns {AxiosPromise}
 */
export function getErpOrderPackSelect(data) {
  return request({
    url: 'api/getErpOrderPackSelect',
    method: 'post',
    params: data
  })
}

/**
 * 订单包装补件
 * @param data
 * @returns {AxiosPromise}
 */
export function ErpOrderPackPatch(data) {
  return request({
    url: 'api/ErpOrderPackPatch',
    method: 'post',
    params: data
  })
}

/**
 * 获取订单补件记录列表
 * @param data
 * @returns {AxiosPromise}
 */
export function getErpOrderPatchRecordList(data) {
  return request({
    url: 'api/getErpOrderPatchRecordList',
    method: 'post',
    params: data
  })
}

/**
 * 获取订单补件记录部件列表
 * @param data
 * @returns {AxiosPromise}
 */
export function getErpOrderPatchRecordInfoList(data) {
  return request({
    url: 'api/getErpOrderPatchRecordInfoList',
    method: 'post',
    params: data
  })
}

/**
 * 获取已包部件列表
 * @param data
 * @returns {AxiosPromise}
 */
export function getErpOrderPackagedPartsList(data) {
  return request({
    url: 'api/getErpOrderPackagedPartsList',
    method: 'post',
    params: data
  })
}

/**
 * 根据包标签号查询包信息
 * @param data
 * @returns {AxiosPromise}
 */
export function getPackageInfoByCode(data) {
  return request({
    url: 'api/getPackageInfoByCode',
    method: 'post',
    params: data
  })
}

/**
 * 包入库操作
 * @param data
 * @returns {AxiosPromise}
 */
export function packageInStock(data) {
  return request({
    url: 'api/packageInStock',
    method: 'post',
    params: data
  })
}

/**
 * 获取库存管理列表
 * @param data
 * @returns {AxiosPromise}
 */
export function getErpInStockList(data) {
  return request({
    url: 'api/getErpInStockList',
    method: 'post',
    params: data
  })
}
/**
 * excel导出发货清单
 * @param data
 * @returns {AxiosPromise}
 */
export function exportShippingList(data) {
  return request({
    url: 'api/exportShippingList',
    method: 'post',
    params: data
  })
}
/**
 * 尾款结清列表
 * @param data
 * @returns {AxiosPromise}
 */
export function getBalanceList(data) {
  return request({
    url: 'api/getBalanceList',
    method: 'post',
    params: data
  })
}

/**
 * 尾款结清列表导出
 * @param data
 * @returns {AxiosPromise}
 */
export function exportBalanceExcel(data) {
  return request({
    url: 'api/exportBalanceExcel',
    method: 'post',
    params: data
  })
}

/**
 * 扣除尾款操作
 * @param data
 * @returns {AxiosPromise}
 */
export function deductBalance(data) {
  return request({
    url: 'api/deductBalance',
    method: 'post',
    params: data
  })
}

/**
 * 出库申请列表
 * @param data
 * @returns {AxiosPromise}
 */
export function getOutApplyList(data) {
  return request({
    url: 'api/getOutApplyList',
    method: 'post',
    params: data
  })
}

/**
 * 包出库申请操作
 * @param data
 * @returns {AxiosPromise}
 */
export function applyOutStock(data) {
  return request({
    url: 'api/applyOutStock',
    method: 'post',
    params: data
  })
}

/**
 * 出库列表
 * @param data
 * @returns {AxiosPromise}
 */
export function getOutStockList(data) {
  return request({
    url: 'api/getOutStockList',
    method: 'post',
    params: data
  })
}

/**
 * 出库申请详情
 * @param data
 * @returns {AxiosPromise}
 */
export function getOutApplyDetail(data) {
  return request({
    url: 'api/getOutApplyDetail',
    method: 'post',
    params: data
  })
}

/**
 * 出库操作
 * @param data
 * @returns {AxiosPromise}
 */
export function outStock(data) {
  return request({
    url: 'api/outStock',
    method: 'post',
    params: data
  })
}

/**
 * 配件出库操作
 * @param data
 * @returns {AxiosPromise}
 */
export function accessOutStock(data) {
  return request({
    url: 'api/accessOutStock',
    method: 'post',
    params: data
  })
}

/**
 * 订单拆分
 * @param data
 * @returns {AxiosPromise}
 */
export function orderSplit(data) {
  return request({
    url: 'api/orderSplit',
    method: 'post',
    params: data
  })
}

/**
 * 填写预计拆单完成时间
 * @param data
 * @returns {AxiosPromise}
 */
export function expectSplit(data) {
  return request({
    url: 'api/expectSplit',
    method: 'post',
    params: data
  })
}

/**
 * 订单拆分记录
 * @param data
 * @returns {AxiosPromise}
 */
export function getOrderSplitRecord(data) {
  return request({
    url: 'api/getOrderSplitRecord',
    method: 'post',
    params: data
  })
}

/**
 * 订单可拆单数信息
 * @param data
 * @returns {AxiosPromise}
 */
export function getSplitInfo(data) {
  return request({
    url: 'api/getSplitInfo',
    method: 'post',
    params: data
  })
}

/**
 * 订单核对
 * @param data
 * @returns {AxiosPromise}
 */
export function chkOrder(data) {
  return request({
    url: 'api/chkOrder',
    method: 'post',
    params: data
  })
}

/**
 * 订单作废
 * @param data
 * @returns {AxiosPromise}
 */
export function orderInvalid(data) {
  return request({
    url: 'api/orderInvalid',
    method: 'post',
    params: data
  })
}

/**
 * 订单作废记录
 * @param data
 * @returns {AxiosPromise}
 */
export function getOrderInvalidList(data) {
  return request({
    url: 'api/getOrderInvalidList',
    method: 'post',
    params: data
  })
}

/**
 * 售后申请列表
 * @param data
 * @returns {AxiosPromise}
 */
export function getAfterSaleList(data) {
  return request({
    url: 'api/getAfterSaleList',
    method: 'post',
    params: data
  })
}

/**
 * 售后单订单选择列表
 * @param data
 * @returns {AxiosPromise}
 */
export function getAfterSaleOrder(data) {
  return request({
    url: 'api/getAfterSaleOrder',
    method: 'post',
    params: data
  })
}

/**
 * 添加或更新售后信息
 * @param data
 * @returns {AxiosPromise}
 */
export function addOrEditAfterDetail(data) {
  return request({
    url: 'api/addOrEditAfterDetail',
    method: 'post',
    params: data
  })
}

/**
 * 删除售后申请
 * @param data
 * @returns {AxiosPromise}
 */
export function deleteAfterSale(data) {
  return request({
    url: 'api/deleteAfterSale',
    method: 'post',
    params: data
  })
}

/**
 * 售后单详情
 * @param data
 * @returns {AxiosPromise}
 */
export function afterSaleDetail(data) {
  return request({
    url: 'api/afterSaleDetail',
    method: 'post',
    params: data
  })
}

/**
 * 售后处理列表
 * @param data
 * @returns {AxiosPromise}
 */
export function getAfterProcessList(data) {
  return request({
    url: 'api/getAfterProcessList',
    method: 'post',
    params: data
  })
}

/**
 * 售后处理页面信息
 * @param data
 * @returns {AxiosPromise}
 */
export function getAfterSalePageInfo(data) {
  return request({
    url: 'api/getAfterSalePageInfo',
    method: 'post',
    params: data
  })
}

/**
 * 售后原因类型
 * @param data
 * @returns {AxiosPromise}
 */
export function getAfterReason() {
  return request({
    url: 'api/getAfterReason',
    method: 'post'
  })
}

/**
 * 售后处理驳回操作
 * @param data
 * @returns {AxiosPromise}
 */
export function turnDownAfterSale(data) {
  return request({
    url: 'api/turnDownAfterSale',
    method: 'post',
    params: data
  })
}

/**
 * 修改售后信息
 * @param data
 * @returns {AxiosPromise}
 */
export function editAfterSaleInfo(data) {
  return request({
    url: 'api/editAfterSaleInfo',
    method: 'post',
    params: data
  })
}

/**
 * 售后赔款列表
 * @param data
 * @returns {AxiosPromise}
 */
export function getAfterIndemnityList(data) {
  return request({
    url: 'api/getAfterIndemnityList',
    method: 'post',
    params: data
  })
}

/**
 * 售后赔款详情
 * @param data
 * @returns {AxiosPromise}
 */
export function getAfterIndemnityDetail(data) {
  return request({
    url: 'api/getAfterIndemnityDetail',
    method: 'post',
    params: data
  })
}

/**
 * 售后赔款审核操作
 * @param data
 * @returns {AxiosPromise}
 */
export function afterIndemnity(data) {
  return request({
    url: 'api/afterIndemnity',
    method: 'post',
    params: data
  })
}

/**
 * 再次提交售后赔款申请
 * @param data
 * @returns {AxiosPromise}
 */
export function againAfterIndemnity(data) {
  return request({
    url: 'api/againAfterIndemnity',
    method: 'post',
    params: data
  })
}

/**
 * 获取整体订单列表
 * @param data
 * @returns {AxiosPromise}
 */
export function getALLOrderList(data) {
  return request({
    url: 'api/getALLOrderList',
    method: 'post',
    params: data
  })
}

/**
 * 获取订单详情
 * @param data
 * @returns {AxiosPromise}
 */
export function getOrderDetail(data) {
  return request({
    url: 'api/getOrderDetail',
    method: 'post',
    params: data
  })
}

/**
 * 获取订单多工厂列表
 * @param data
 * @returns {AxiosPromise}
 */
export function getMultiFactory(data) {
  return request({
    url: 'api/getMultiFactory',
    method: 'post',
    params: data
  })
}

/**
 * 获取订单跟踪
 * @param data
 * @returns {AxiosPromise}
 */
export function getOrderTrack(data) {
  return request({
    url: 'api/getOrderTrack',
    method: 'post',
    params: data
  })
}

/**
 * 获取订单跟踪
 * @param data
 * @returns {AxiosPromise}
 */
export function getOrderDynamic(data) {
  return request({
    url: 'api/getOrderDynamic',
    method: 'post',
    params: data
  })
}

/**
 * 添加订单动态信息
 * @param data
 * @returns {AxiosPromise}
 */
export function addOrderDynamic(data) {
  return request({
    url: 'api/addOrderDynamic',
    method: 'post',
    params: data
  })
}

/**
 * 获取订单报价信息
 * @param data
 * @returns {AxiosPromise}
 */
export function getOrderQuoteDetail(data) {
  return request({
    url: 'api/getOrderQuoteDetail',
    method: 'post',
    params: data
  })
}

/**
 * 根据订单ID查询订单信息
 * @param data
 * @returns {AxiosPromise}
 */
export function getOrderById(data) {
  return request({
    url: 'api/getOrderById',
    method: 'post',
    params: data
  })
}

/**
 * 工厂折扣金额
 */
export function getFactoryPrice(data) {
  return request({
    url: 'api/getFactoryPrice',
    method: 'post',
    params: data
  })
}

/**
 * 删除部件条码
 */
export function deleteBarcode(data) {
  return request({
    url: 'api/deleteBarcode',
    method: 'post',
    params: data
  })
}

/**
 * 条码删除记录
 * @param data
 */
export function getDeleteRecord(data) {
  return request({
    url: 'api/getDeleteRecord',
    method: 'post',
    params: data
  })
}

/**
 * 还原删除的条码
 * @param data
 */
export function revertBarcode(data) {
  return request({
    url: 'api/revertBarcode',
    method: 'post',
    params: data
  })
}

/**
 * 订单收款记录
 * @param data
 */
export function orderCollectRecord(data) {
  return request({
    url: 'api/orderCollectRecord',
    method: 'post',
    params: data
  })
}

/**
 * 生产批量接单
 * @param data
 */
export function batchScJd(data) {
  return request({
    url: 'api/batchScJd',
    method: 'post',
    params: data
  })
}

/**
 * 获取外车间订单列表
 * @param data
 */
export function getALLOrderListOfOuter(data) {
  return request({
    url: 'api/getALLOrderListOfOuter',
    method: 'post',
    params: data
  })
}

/**
 * 包装清尾打印
 * @param data
 */
export function PrintOrderByPackInfoDetailAll(data) {
  return request({
    url: 'api/PrintOrderByPackInfoDetailAll',
    method: 'post',
    params: data
  })
}

/**
 * 包装生产报表
 * @param data
 */
export function getErpPackRepor(data) {
  return request({
    url: 'api/getErpPackRepor',
    method: 'post',
    params: data
  })
}

/**
 * 包装完成报表
 * @param data
 */
export function getErpPackFinishReport(data) {
  return request({
    url: 'api/getErpPackFinishReport',
    method: 'post',
    params: data
  })
}

/**
 * 入库报表
 * @param data
 */
export function getErpInReport(data) {
  return request({
    url: 'api/getErpInReport',
    method: 'post',
    params: data
  })
}

/**
 * 修改订单预付付款比例
 * @param data
 */
export function editOrderDiscount(data) {
  return request({
    url: 'api/editOrderDiscount',
    method: 'post',
    params: data
  })
}

/**
 * 打包完成
 * @param data
 */
export function completePack(data) {
  return request({
    url: 'api/completePack',
    method: 'post',
    params: data
  })
}

/**
 * 获取改价记录
 * @param data
 */
export function getChangeOfferRecord(data) {
  return request({
    url: 'api/getChangeOfferRecord',
    method: 'post',
    params: data
  })
}

/**
 * 获取打款内容
 * @param data
 */
export function getPaycontent() {
  return request({
    url: 'api/getPaycontent',
    method: 'post'
  })
}

/**
 * 添加/编辑订单收款
 * @param data
 */
export function editOrderCollectRecord(data) {
  return request({
    url: 'api/editOrderCollectRecord',
    method: 'post',
    params: data
  })
}

/**
 * 获取打款内容
 * @param data
 */
export function delOrderCollectRecord(data) {
  return request({
    url: 'api/delOrderCollectRecord',
    method: 'post',
    params: data
  })
}

/**
 * 添加订单退款申请
 * @param data
 */
export function doRefund(data) {
  return request({
    url: 'api/doRefund',
    method: 'post',
    params: data
  })
}

/**
 * 删除冲业绩收款
 * @param data
 */
export function delAchievementApply(data) {
  return request({
    url: 'api/delAchievementApply',
    method: 'post',
    params: data
  })
}

/**
 * 获取改价图片和备注
 * @param data
 */
export function getOrderDiscount(data) {
  return request({
    url: 'api/getOrderDiscount',
    method: 'post',
    params: data
  })
}
/**
 * 获取打款内容
 * @param data
 */
export function printPackList(data) {
  return request({
    url: 'api/printPackList',
    method: 'post',
    params: data
  })
}

/**
 * 获取生产料单变更列表
 * getParameter
 * @param data
 */
export function getALLScldbgOrderList(data) {
  return request({
    url: 'api/getALLScldbgOrderList',
    method: 'post',
    params: data
  })
}

/**
 * 生产动态进度
 * @param data
 * @returns {AxiosPromise}
 */
export function getOrderSchedule(data) {
  return request({
    url: 'api/getOrderSchedule',
    method: 'post',
    params: data
  })
}

/**
 * 打印发货清单
 * getParameter
 * @param data
 */
export function printShippingList(data) {
  return request({
    url: 'api/printShippingList',
    method: 'post',
    params: data
  })
}

/**
 * 获取发货记录
 * @param data
 * @returns {AxiosPromise}
 */
export function getDeliveryRecord(data) {
  return request({
    url: 'api/getDeliveryRecord',
    method: 'post',
    params: data
  })
}

/**
 * 售后投诉处理单打印
 * @param data
 * @returns {AxiosPromise}
 */
export function printComplaintsSale(data) {
  return request({
    url: 'api/printComplaintsSale',
    method: 'post',
    params: data
  })
}

/**
 * 添加/编辑料单部件
 * getParameter
 * @param data
 */
export function editMaterialdata(data) {
  return request({
    url: 'api/editMaterialdata',
    method: 'post',
    params: data
  })
}

/**
 * 获取订单料单变更记录
 * getParameter
 * @param data
 */
export function getOrderMchangelog(data) {
  return request({
    url: 'api/getOrderMchangelog',
    method: 'post',
    params: data
  })
}

/**
 * 获取订单料单变更记录
 * getParameter
 * @param data
 */
export function delMaterialdata(data) {
  return request({
    url: 'api/delMaterialdata',
    method: 'post',
    params: data
  })
}

/**
 * 审单操作
 * getParameter
 * @param data
 */
export function reviewOrder(data) {
  return request({
    url: 'api/reviewOrder',
    method: 'post',
    params: data
  })
}

/**
 * 订单完成
 * @param data
 */
export function orderOver(data) {
  return request({
    url: 'api/orderOver',
    method: 'post',
    params: data
  })
}

/**
 * 订单完成记录
 * @param data
 */
export function getOrderOverList(data) {
  return request({
    url: 'api/getOrderOverList',
    method: 'post',
    params: data
  })
}

/**
 * 通知
 * @param data
 */
export function getOrderNotice(data) {
  return request({
    url: 'api/getOrderNotice',
    method: 'post',
    params: data
  })
}
/**
 * 通知已读
 * @param data
 */
export function addOrderNoticeRead(data) {
  return request({
    url: 'api/addOrderNoticeRead',
    method: 'post',
    params: data
  })
}

/**
 * 添加/编辑经销商客服确认收款申请
 * @param data
 */
export function addOrEditCollectApplyConfirm(data) {
  return request({
    url: 'api/addOrEditCollectApplyConfirm',
    method: 'post',
    params: data
  })
}

/**
 * 客服确认经销商收款申请
 * @param data
 */
export function confirmCollectionInfo(data) {
  return request({
    url: 'api/confirmCollectionInfo',
    method: 'post',
    params: data
  })
}

/**
 * 客服确认经销商收款申请作废操作
 * @param data
 */
export function voidCollectionInfo(data) {
  return request({
    url: 'api/voidCollectionInfo',
    method: 'post',
    params: data
  })
}

/**
 * 拆单统计分析
 * @param data
 * @returns {AxiosPromise}
 */
export function getSplitAnalysis(data) {
  return request({
    url: 'api/getSplitAnalysis',
    method: 'post',
    params: data
  })
}
/**
 * 拆单统计拆单员详情
 * @param data
 * @returns {AxiosPromise}
 */
export function getSplitAnalysisDetail(data) {
  return request({
    url: 'api/getSplitAnalysisDetail',
    method: 'post',
    params: data
  })
}
/**
 * 拆单统计导出
 * @param data
 * @returns {AxiosPromise}
 */
export function excelSplitAnalysis(data) {
  return request({
    url: 'api/excelSplitAnalysis',
    method: 'post',
    params: data
  })
}
/**
 * 拆单部数据统计
 * @param data
 * @returns {AxiosPromise}
 */
export function getSplitData(data) {
  return request({
    url: 'api/getSplitData',
    method: 'post',
    params: data
  })
}
/**
 * 报价统计分析
 * @param data
 * @returns {AxiosPromise}
 */
export function getOfferCraftsAnalysis(data) {
  return request({
    url: 'api/getOfferCraftsAnalysis',
    method: 'post',
    params: data
  })
}
/**
 * 报价统计详情
 * @param data
 * @returns {AxiosPromise}
 */
export function getOfferCraftsAnalysisDetail(data) {
  return request({
    url: 'api/getOfferCraftsAnalysisDetail',
    method: 'post',
    params: data
  })
}
/**
 * 报价均价统计分析
 * @param data
 * @returns {AxiosPromise}
 */
export function getOfferAvgPrice(data) {
  return request({
    url: 'api/getOfferAvgPrice',
    method: 'post',
    params: data
  })
}
/**
 * 区域经理业绩统计分析
 * @param data
 * @returns {AxiosPromise}
 */
export function areaTargets(data) {
  return request({
    url: 'api/areaTargets',
    method: 'post',
    params: data
  })
}
/**
 * 添加区域经理业绩目标
 * @param data
 * @returns {AxiosPromise}
 */
export function addAreaTarget(data) {
  return request({
    url: 'api/addAreaTarget',
    method: 'post',
    params: data
  })
}
/**
 * 编辑区域经理业绩目标
 * @param data
 * @returns {AxiosPromise}
 */
export function editAreaTarget(data) {
  return request({
    url: 'api/editAreaTarget',
    method: 'post',
    params: data
  })
}
/**
 * 删除区域经理业绩目标
 * @param data
 * @returns {AxiosPromise}
 */
export function delAreaTarget(data) {
  return request({
    url: 'api/delAreaTarget',
    method: 'post',
    params: data
  })
}
/**
 * 区域经理业绩目标统计
 * @param data
 * @returns {AxiosPromise}
 */
export function areaTargetStatistics(data) {
  return request({
    url: 'api/areaTargetStatistics',
    method: 'post',
    params: data
  })
}
/**
 * 区域经理业绩目标订单列表详情
 * @param data
 * @returns {AxiosPromise}
 */
export function areaTargetStatisticDetail(data) {
  return request({
    url: 'api/areaTargetStatisticDetail',
    method: 'post',
    params: data
  })
}
/**
 * 区域经理月度业绩
 * @param data
 * @returns {AxiosPromise}
 */
export function areaMonthTargets(data) {
  return request({
    url: 'api/areaMonthTargets',
    method: 'post',
    params: data
  })
}
/**
 * 区域经理月度业绩订单列表详情
 * @param data
 * @returns {AxiosPromise}
 */
export function areaMonthTargetDetail(data) {
  return request({
    url: 'api/areaMonthTargetDetail',
    method: 'post',
    params: data
  })
}
/**
 * 添加经销商业绩目标
 * @param data
 * @returns {AxiosPromise}
 */
export function addYjTarget(data) {
  return request({
    url: 'api/addYjTarget',
    method: 'post',
    params: data
  })
}
/**
 * 编辑经销商业绩目标
 * @param data
 * @returns {AxiosPromise}
 */
export function editYjTarget(data) {
  return request({
    url: 'api/editYjTarget',
    method: 'post',
    params: data
  })
}
/**
 * 删除经销商业绩目标
 * @param data
 * @returns {AxiosPromise}
 */
export function delYjTarget(data) {
  return request({
    url: 'api/delYjTarget',
    method: 'post',
    params: data
  })
}
/**
 * 查询经销商业绩目标
 * @param data
 * @returns {AxiosPromise}
 */
export function yjTargets(data) {
  return request({
    url: 'api/yjTargets',
    method: 'post',
    params: data
  })
}
/**
 * 添加经销商业绩合同
 * @param data
 * @returns {AxiosPromise}
 */
export function addYjContract(data) {
  return request({
    url: 'api/addYjContract',
    method: 'post',
    params: data
  })
}
/**
 * 编辑经销商业绩合同
 * @param data
 * @returns {AxiosPromise}
 */
export function editYjContract(data) {
  return request({
    url: 'api/editYjContract',
    method: 'post',
    params: data
  })
}
/**
 * 删除经销商业绩合同
 * @param data
 * @returns {AxiosPromise}
 */
export function delYjContract(data) {
  return request({
    url: 'api/delYjContract',
    method: 'post',
    params: data
  })
}
/**
 * 查询经销商业绩合同
 * @param data
 * @returns {AxiosPromise}
 */
export function yjContracts(data) {
  return request({
    url: 'api/yjContracts',
    method: 'post',
    params: data
  })
}
/**
 * 查询经销商业绩统计
 * @param data
 * @returns {AxiosPromise}
 */
export function yjMonth(data) {
  return request({
    url: 'api/yjMonth',
    method: 'post',
    params: data
  })
}
/**
 * 添加或编辑业绩/支票返点申请
 * @param data
 */
export function addOrEditDealerAccountRebate(data) {
  return request({
    url: 'api/addOrEditDealerAccountRebate',
    method: 'post',
    params: data
  })
}

/**
 * 业绩/支票返点申请列表
 * @param data
 */
export function getDealerAccountRebateApplyList(data) {
  return request({
    url: 'api/getDealerAccountRebateApplyList',
    method: 'post',
    params: data
  })
}

/**
 * 导出业绩/支票返点申请列表
 * @param data
 */
export function excelDealerAccountRebateApplyList(data) {
  return request({
    url: 'api/excelDealerAccountRebateApplyList',
    method: 'post',
    params: data
  })
}

export function exportCollectionApplyList(data) {
  return request({
    url: 'api/exportCollectionApplyList',
    method: 'post',
    params: data
  })
}

/**
 * 删除业绩/支票返点申请
 * @param data
 */
export function deleteDealerAccountRebate(data) {
  return request({
    url: 'api/deleteDealerAccountRebate',
    method: 'post',
    params: data
  })
}

/**
 * 获取业绩/支票返点申请
 * @param data
 */
export function getDealerAccountRebateById(data) {
  return request({
    url: 'api/getDealerAccountRebateById',
    method: 'post',
    params: data
  })
}

/**
 * 业绩/支票返点审核操作
 * @param data
 */
export function reviewDealerAccountRebate(data) {
  return request({
    url: 'api/reviewDealerAccountRebate',
    method: 'post',
    params: data
  })
}

/**
 * 添加或编辑售后赔款申请
 * @param data
 */
export function addOrEditDealerAccountAfter(data) {
  return request({
    url: 'api/addOrEditDealerAccountAfter',
    method: 'post',
    params: data
  })
}

/**
 * 售后赔款申请列表
 * @param data
 */
export function getDealerAccountAfterApplyList(data) {
  return request({
    url: 'api/getDealerAccountAfterApplyList',
    method: 'post',
    params: data
  })
}
/**
 * 导出售后赔款申请列表
 * @param data
 */
export function excelDealerAccountAfterApplyList(data) {
  return request({
    url: 'api/excelDealerAccountAfterApplyList',
    method: 'post',
    params: data
  })
}

/**
 * 获取售后赔款申请
 * @param data
 */
export function getDealerAccountAfterById(data) {
  return request({
    url: 'api/getDealerAccountAfterById',
    method: 'post',
    params: data
  })
}

/**
 * 删除售后赔款申请
 * @param data
 */
export function deleteDealerAccountAfter(data) {
  return request({
    url: 'api/deleteDealerAccountAfter',
    method: 'post',
    params: data
  })
}

/**
 * 售后赔款审核操作
 * @param data
 */
export function reviewDealerAccountAfter(data) {
  return request({
    url: 'api/reviewDealerAccountAfter',
    method: 'post',
    params: data
  })
}

/**
 * 添加或编辑报备金申请
 * @param data
 */
export function addOrEditDealerAccountReport(data) {
  return request({
    url: 'api/addOrEditDealerAccountReport',
    method: 'post',
    params: data
  })
}

/**
 * 报备金申请列表
 * @param data
 */
export function getDealerAccountReportApplyList(data) {
  return request({
    url: 'api/getDealerAccountReportApplyList',
    method: 'post',
    params: data
  })
}

/**
 * 获取报备金详情
 * @param data
 */
export function getDealerAccountReportById(data) {
  return request({
    url: 'api/getDealerAccountReportById',
    method: 'post',
    params: data
  })
}

/**
 * 删除报备金申请
 * @param data
 */
export function deleteDealerAccountReport(data) {
  return request({
    url: 'api/deleteDealerAccountReport',
    method: 'post',
    params: data
  })
}

/**
 * 报备金审核操作
 * @param data
 */
export function reviewDealerAccountReport(data) {
  return request({
    url: 'api/reviewDealerAccountReport',
    method: 'post',
    params: data
  })
}

/**
 * 获取经销商账户详情(员工)
 * @param data
 */
export function getDealerAccountDataByStaff(data) {
  return request({
    url: 'api/getDealerAccountDataByStaff',
    method: 'post',
    params: data
  })
}

/**
 * 获取经销商报备订单终端地址
 * @param data
 */
export function getDealerAccountReportByDelid(data) {
  return request({
    url: 'api/getDealerAccountReportByDelid',
    method: 'post',
    params: data
  })
}

/**
 * 根据订单获取相关返点及报备金折扣
 * @param data
 */
export function getRebateAndReportByOrderid(data) {
  return request({
    url: 'api/getRebateAndReportByOrderid',
    method: 'post',
    params: data
  })
}

/**
 * 根据订单获取业绩/支票返点列表
 * @param data
 */
export function getDealerAccountRebateListByOrderid(data) {
  return request({
    url: 'api/getDealerAccountRebateListByOrderid',
    method: 'post',
    params: data
  })
}
/**
 * 获取订单周期汇总表
 * @param data
 */
export function getOrderCycleSummary(data) {
  return request({
    url: 'api/getOrderCycleSummary',
    method: 'post',
    params: data
  })
}

/**
 * 根据订单获取售后赔款列表
 * @param data
 */
export function getDealerAccountAfterListByOrderid(data) {
  return request({
    url: 'api/getDealerAccountAfterListByOrderid',
    method: 'post',
    params: data
  })
}

/**
 * 根据订单获取售后赔款列表
 * @param data
 */
export function getDealerAccountReportListByOrderid(data) {
  return request({
    url: 'api/getDealerAccountReportListByOrderid',
    method: 'post',
    params: data
  })
}

/**
 * 根据订单收款记录ID查询详情
 * @param data
 */
export function getCollectRecordByCrid(data) {
  return request({
    url: 'api/getCollectRecordByCrid',
    method: 'post',
    params: data
  })
}

/**
 * 根据收款申请ID查询详情
 * @param data
 */
export function getReceiptApplyByRaid(data) {
  return request({
    url: 'api/getReceiptApplyByRaid',
    method: 'post',
    params: data
  })
}

/**
 * 冲业绩账户列表
 * @param data
 */
export function getDealerAchievementList(data) {
  return request({
    url: 'api/getDealerAchievementList',
    method: 'post',
    params: data
  })
}

/**
 * 业绩/支票返点账户列表
 * @param data
 */
export function getDealerAccountRebateList(data) {
  return request({
    url: 'api/getDealerAccountRebateList',
    method: 'post',
    params: data
  })
}

/**
 * 业绩/支票返点账户列表
 * @param data
 */
export function getDealerReceiptAccountList(data) {
  return request({
    url: 'api/getDealerReceiptAccountList',
    method: 'post',
    params: data
  })
}

/**
 * 售后赔款账户列表
 * @param data
 */
export function getDealerAccountAfterList(data) {
  return request({
    url: 'api/getDealerAccountAfterList',
    method: 'post',
    params: data
  })
}

/**
 * 报备金账户列表
 * @param data
 */
export function getDealerAccountReportList(data) {
  return request({
    url: 'api/getDealerAccountReportList',
    method: 'post',
    params: data
  })
}

/**
 * 获取零售项目
 * @param data
 */
export function getProjects(data) {
  return request({
    url: 'api/getProjects',
    method: 'post',
    params: data
  })
}
/**
 * 添加/编辑零售项目
 * @param data
 */
export function addOrEditProject(data) {
  return request({
    url: 'api/addOrEditProject',
    method: 'post',
    params: data
  })
}

/**
 * 获取零售项目使用记录
 * @param data
 */
export function getProjectApplys(data) {
  return request({
    url: 'api/getProjectApplys',
    method: 'post',
    params: data
  })
}
/**
 * 添加/编辑零售项目申请
 * @param data
 */
export function addOrEditProjectApply(data) {
  return request({
    url: 'api/addOrEditProjectApply',
    method: 'post',
    params: data
  })
}

/**
 * 获取收款对账单列表
 * @param data
 */
export function getReceiptStatementList(data) {
  return request({
    url: 'api/getReceiptStatementList',
    method: 'post',
    params: data
  })
}

/**
 * 打印收款对账单
 * @param data
 */
export function printReceiptStatement(data) {
  return request({
    url: 'api/printReceiptStatement',
    method: 'post',
    params: data
  })
}

/**
 * 获取现金收入对账单列表
 * @param data
 */
export function getBusinessStatement(data) {
  return request({
    url: 'api/getBusinessStatement',
    method: 'post',
    params: data
  })
}

/**
 * 获取现金收入对账单列表
 * @param data
 */
export function getCashIncomeStatementList(data) {
  return request({
    url: 'api/getCashIncomeStatementList',
    method: 'post',
    params: data
  })
}

/**
 * 打印招商收款对账单
 * @param data
 */
export function printBusinessStatement(data) {
  return request({
    url: 'api/printBusinessStatement',
    method: 'post',
    params: data
  })
}

/**
 * 经销商账户对账单
 * @param data
 */
export function getDealerAccountsStatement(data) {
  return request({
    url: 'api/getDealerAccountsStatement',
    method: 'post',
    params: data
  })
}

/**
 * 导出经销商账户对账单excel
 * @param data
 * @returns
 */
export function excelDealerAccountsStatement(data) {
  return request({
    url: 'api/excelDealerAccountsStatement',
    method: 'post',
    params: data
  })
}

/**
 * 打印经销商账户对账单
 * @param data
 * @returns
 */
export function printDealerAccountsStatement(data) {
  return request({
    url: 'api/printDealerAccountsStatement',
    method: 'post',
    params: data
  })
}

/**
 * 订单收款对账单
 * @param data
 */
export function getCollectionStatement(data) {
  return request({
    url: 'api/getCollectionStatement',
    method: 'post',
    params: data
  })
}

/**
 * 导出订单收款对账单excel
 * @param data
 * @returns
 */
export function excelCollectionStatement(data) {
  return request({
    url: 'api/excelCollectionStatement',
    method: 'post',
    params: data
  })
}

/**
 * 打印订单收款对账单
 * @param data
 * @returns
 */
export function printCollectionStatement(data) {
  return request({
    url: 'api/printCollectionStatement',
    method: 'post',
    params: data
  })
}

/**
 * 打印现金收入对账单
 * @param data
 */
export function printCashIncomeStatement(data) {
  return request({
    url: 'api/printCashIncomeStatement',
    method: 'post',
    params: data
  })
}

/**
 * 获取订单核价列表
 * @param data
 */
export function getOrderNuclearPriceList(data) {
  return request({
    url: 'api/getOrderNuclearPriceList',
    method: 'post',
    params: data
  })
}

/**
 * 获取订单核价详情
 * @param data
 */
export function getOrderNuclearPriceDetail(data) {
  return request({
    url: 'api/getOrderNuclearPriceDetail',
    method: 'post',
    params: data
  })
}

/**
 * 导出招商收款对账单excel
 * @param data
 */
export function excelBusinessStatement(data) {
  return request({
    url: 'api/excelBusinessStatement',
    method: 'post',
    params: data
  })
}

/**
 * 导出现金收入对帐单
 * @param data
 */
export function excelCashIncomeStatement(data) {
  return request({
    url: 'api/excelCashIncomeStatement',
    method: 'post',
    params: data
  })
}

/**
 * 订单查价
 * @param data
 */
export function getOrderSelectPriceList(data) {
  return request({
    url: 'api/getOrderSelectPriceList',
    method: 'post',
    params: data
  })
}

/**
 * 订单核价导出
 * @param data
 */
export function exportOrderNuclearPriceExcel(data) {
  return request({
    url: 'api/exportOrderNuclearPriceExcel',
    method: 'post',
    params: data
  })
}

/**
 * 订单汇总表导出
 * @param data
 */
export function exportOrderQueryPriceExcel(data) {
  return request({
    url: 'api/exportOrderQueryPriceExcel',
    method: 'post',
    params: data
  })
}

/**
 * 订单列表导出
 * @param data
 */
export function exportOrderExcel(data) {
  return request({
    url: 'api/exportOrderExcel',
    method: 'post',
    params: data
  })
}
/**
 * 订单列周期汇总列表导出
 * @param data
 */
export function OrderCycleSummaryExcel(data) {
  return request({
    url: 'api/OrderCycleSummaryExcel',
    method: 'post',
    params: data
  })
}

/**
 * 收款审核现金收入打印
 * @param data
 */
export function printCollectionApplyList(data) {
  return request({
    url: 'api/printCollectionApplyList',
    method: 'post',
    params: data
  })
}

/**
 * 订单收款统计
 * @param data
 */
export function getCollectionStatistics(data) {
  return request({
    url: 'api/getCollectionStatistics',
    method: 'post',
    params: data
  })
}

/**
 * 营销数据统计
 * @param data
 */
export function getYxtj(data) {
  return request({
    url: 'api/getYxtj',
    method: 'post',
    params: data
  })
}

/**
 * 营销数据统计2
 * @param data
 */
export function getYxtj2(data) {
  return request({
    url: 'api/getYxtj2',
    method: 'post',
    params: data
  })
}
/**
 * 营销数据统计2 导出
 * @param data
 */
export function excelYxtj2(data) {
  return request({
    url: 'api/excelYxtj2',
    method: 'post',
    params: data
  })
}
/**
 * 营销数据统计2 导出明细
 * @param data
 */
export function excelYxtjDetail2(data) {
  return request({
    url: 'api/excelYxtjDetail2',
    method: 'post',
    params: data
  })
}

/**
 * 客服数据统计
 * @param data
 */
export function getServeStatistics(data) {
  return request({
    url: 'api/getServeStatistics',
    method: 'post',
    params: data
  })
}

/**
 * 区域数据统计
 * @param data
 */
export function getAreaStatistics(data) {
  return request({
    url: 'api/getAreaStatistics',
    method: 'post',
    params: data
  })
}

/**
 * 经销商数据统计
 * @param data
 */
export function getDealerOrderStatistics(data) {
  return request({
    url: 'api/getDealerOrderStatistics',
    method: 'post',
    params: data
  })
}

/**
 * 订单收款统计详情列表
 * @param data
 */
export function getCollectionDetail(data) {
  return request({
    url: 'api/getCollectionDetail',
    method: 'post',
    params: data
  })
}

/**
 * 导出订单收款统计详情列表
 * @param data
 */
export function excelCollectionDetail(data) {
  return request({
    url: 'api/excelCollectionDetail',
    method: 'post',
    params: data
  })
}

/**
 * 售后汇总数据
 * @param data
 */
export function getAfterSummaryList(data) {
  return request({
    url: 'api/getAfterSummaryList',
    method: 'post',
    params: data
  })
}

/**
 * 售后汇总数据导出
 * @param data
 */
export function exportAfterSummaryList(data) {
  return request({
    url: 'api/exportAfterSummaryList',
    method: 'post',
    params: data
  })
}

/**
 * 获取报价分析订单列表详情
 * @param data
 */
export function getOfferAnalysisOrderList(data) {
  return request({
    url: 'api/getOfferAnalysisOrderList',
    method: 'post',
    params: data
  })
}

/**
 * 报价分析订单列表详情导出
 * @param data
 */
export function exportOfferAnalysisOrderListExcel(data) {
  return request({
    url: 'api/exportOfferAnalysisOrderListExcel',
    method: 'post',
    params: data
  })
}

/**
 * 报价分析数据导出
 * @param data
 */
export function excelOfferCraftsAnalysis(data) {
  return request({
    url: 'api/excelOfferCraftsAnalysis',
    method: 'post',
    params: data
  })
}
/**
 * 报价时长统计数据导出
 * @param data
 */
export function excelOfferTime(data) {
  return request({
    url: 'api/excelOfferTime',
    method: 'post',
    params: data
  })
}

/**
 * 订单生产指令单列表
 * @param data
 */
export function getDirectOrderList(data) {
  return request({
    url: 'api/getDirectOrderList',
    method: 'post',
    params: data
  })
}
/**
 * 订单生产指令单列表打印
 * @param data
 */
export function printProduceDirect(data) {
  return request({
    url: 'api/printProduceDirect',
    method: 'post',
    params: data
  })
}

/**
 * 财务订单改价记录
 * @param data
 */
export function getCwOrderChangePriceList(data) {
  return request({
    url: 'api/getCwOrderChangePriceList',
    method: 'post',
    params: data
  })
}
/**
 * 财务订单查证
 * @param data
 */
export function checkChangePrice(data) {
  return request({
    url: 'api/checkChangePrice',
    method: 'post',
    params: data
  })
}
/**
 * 报备金打印
 * @param data
 */
export function printBbjStatementList(data) {
  return request({
    url: 'api/printBbjStatementList',
    method: 'post',
    params: data
  })
}

/**
 * 修改售后图片和文件
 * @param data
 */
export function editAfterSaleFile(data) {
  return request({
    url: 'api/editAfterSaleFile',
    method: 'post',
    params: data
  })
}

/**
 * 经销商打包列表
 * @param data
 */
export function getErpDealerPackList(data) {
  return request({
    url: 'api/getErpDealerPackList',
    method: 'post',
    params: data
  })
}

/**
 * 经销商打包列表打印
 * @param data
 */
export function printErpDealerPack(data) {
  return request({
    url: 'api/printErpDealerPack',
    method: 'post',
    params: data
  })
}
/**
 * 订单工厂重新分派
 * @param data
 */
export function editOrderFactoryAssign(data) {
  return request({
    url: 'api/editOrderFactoryAssign',
    method: 'post',
    params: data
  })
}
/**
 * 拆单设计师订单
 * @param data
 */
export function getDesignerOrderList(data) {
  return request({
    url: 'api/getDesignerOrderList',
    method: 'post',
    params: data
  })
}
/**
 * 拆单设计师
 * @param data
 */
export function getDesignerList(data) {
  return request({
    url: 'api/getDesignerList',
    method: 'post',
    params: data
  })
}

/**
 * 业绩支票返点
 * @param data
 */
export function exportDealerAccountRebateExcel(data) {
  return request({
    url: 'api/exportDealerAccountRebateExcel',
    method: 'post',
    params: data
  })
}

/**
 * 售后赔款
 * @param data
 */
export function exportDealerAfterAccountExcel(data) {
  return request({
    url: 'api/exportDealerAfterAccountExcel',
    method: 'post',
    params: data
  })
}

/**
 * 报备金
 * @param data
 */
export function exportDealerReportAccountExcel(data) {
  return request({
    url: 'api/exportDealerAfterAccountExcel',
    method: 'post',
    params: data
  })
}

/**
 * 料单模板列表
 * @param data
 */
export function getMaterialTemplate(data) {
  return request({
    url: 'api/getMaterialTemplate',
    method: 'post',
    params: data
  })
}

/**
 * 修改添加模板列表
 * @param data
 */
export function addOrEditMaterialTemplate(data) {
  return request({
    url: 'api/addOrEditMaterialTemplate',
    method: 'post',
    params: data
  })
}

/**
 * 删除模板列表
 * @param data
 */
export function deleteMaterialTemplate(data) {
  return request({
    url: 'api/deleteMaterialTemplate',
    method: 'post',
    params: data
  })
}
/**
 * 最新模板
 * @param data
 */
export function getNewestMaterialTemplate(data) {
  return request({
    url: 'api/getNewestMaterialTemplate',
    method: 'post',
    params: data
  })
}

/**
 * 在制作的订单
 * @param data
 */
export function getMakingOrderList(data) {
  return request({
    url: 'api/getMakingOrderList',
    method: 'post',
    params: data
  })
}

/**
 * 订单的木架费用
 * @param data
 */
export function exportGetMakingOrderList(data) {
  return request({
    url: 'api/exportGetMakingOrderList',
    method: 'post',
    params: data
  })
}

/**
 * 获取售后回访列表
 * @param data
 */
export function getAfterVisitList(data) {
  return request({
    url: 'api/getAfterVisitList',
    method: 'post',
    params: data
  })
}

/**
 * 获取报价书列表
 * @param data
 */
export function getQuote(data) {
  return request({
    url: 'api/getQuote',
    method: 'post',
    params: data
  })
}

/**
 * 添加/修改报价书
 * @param data
 */
export function addOrEditQuote(data) {
  return request({
    url: 'api/addOrEditQuote',
    method: 'post',
    params: data
  })
}

/**
 * 删除报价书
 * @param data
 */
export function delQuote(data) {
  return request({
    url: 'api/delQuote',
    method: 'post',
    params: data
  })
}

/**
 * 获取生产报价规则列表
 * @param data
 * @returns {AxiosPromise}
 */
export function getProductQRules(data) {
  return request({
    url: 'api/getProductQRules',
    method: 'post',
    params: data
  })
}

/**
 * 添加生产报价规则
 * @param data
 * @returns {AxiosPromise}
 */
export function addOrEditProductQRules(data) {
  return request({
    url: 'api/addOrEditProductQRules',
    method: 'post',
    params: data
  })
}

/**
 * 删除生产报价规则
 * @param data
 * @returns {AxiosPromise}
 */
export function delProductQRules(data) {
  return request({
    url: 'api/delProductQRules',
    method: 'post',
    params: data
  })
}

/**
 * 获取报价系列分析数据
 * @param data
 */
export function getOfferSeriesAnalysis(data) {
  return request({
    url: 'api/getOfferSeriesAnalysis',
    method: 'post',
    params: data
  })
}

/**
 * 获取订单临时折扣列表
 * @param data
 */
export function getErpDealerAccountTempList(data) {
  return request({
    url: 'api/getErpDealerAccountTempList',
    method: 'post',
    params: data
  })
}

/**
 * 添加编辑订单临时折扣
 * @param data
 */
export function editDealerAccountTemp(data) {
  return request({
    url: 'api/editDealerAccountTemp',
    method: 'post',
    params: data
  })
}

/**
 * 删除订单临时折扣
 * @param data
 */
export function delDealerAccountTemp(data) {
  return request({
    url: 'api/delDealerAccountTemp',
    method: 'post',
    params: data
  })
}

/**
 * 获取订单临时折扣详情
 * @param data
 */
export function getErpDealerAccountTempDetail(data) {
  return request({
    url: 'api/getErpDealerAccountTempDetail',
    method: 'post',
    params: data
  })
}

/**
 * 获取订单临时折扣申请列表
 * @param data
 */
export function getDealerAccountTempApplyList(data) {
  return request({
    url: 'api/getDealerAccountTempApplyList',
    method: 'post',
    params: data
  })
}

/**
 * 订单临时折扣审核操作
 * @param data
 */
export function reviewDealerAccountTemp(data) {
  return request({
    url: 'api/reviewDealerAccountTemp',
    method: 'post',
    params: data
  })
}

/**
 * 售后金额分解列表
 * @param data
 */
export function getAfterAmountBreakdownList(data) {
  return request({
    url: 'api/getAfterAmountBreakdownList',
    method: 'post',
    params: data
  })
}

/**
 * 售后金额分解详情
 * @param data
 */
export function getAfterAmountBreakdownDetail(data) {
  return request({
    url: 'api/getAfterAmountBreakdownDetail',
    method: 'post',
    params: data
  })
}

/**
 * 售后金额分解操作
 * @param data
 */
export function editAfterAmountBreakdown(data) {
  return request({
    url: 'api/editAfterAmountBreakdown',
    method: 'post',
    params: data
  })
}

/**
 * 根据订单ID获取更改单列表
 * @param data
 */
export function getOrderChangeListByOrderid(data) {
  return request({
    url: 'api/getOrderChangeListByOrderid',
    method: 'post',
    params: data
  })
}

/**
 * 添加/编辑更改单
 * @param data
 */
export function editOrderChange(data) {
  return request({
    url: 'api/editOrderChange',
    method: 'post',
    params: data
  })
}

/**
 * 删除更改单
 * @param data
 */
export function delOrderChange(data) {
  return request({
    url: 'api/delOrderChange',
    method: 'post',
    params: data
  })
}

/**
 * 获取更改单详情
 * @param data
 */
export function getOrderChangeDetail(data) {
  return request({
    url: 'api/getOrderChangeDetail',
    method: 'post',
    params: data
  })
}

/**
 * 打印更改单
 * @param data
 * @returns {AxiosPromise}
 */
export function printChangeSheet(data) {
  return request({
    url: 'api/printChangeSheet',
    method: 'post',
    params: data
  })
}
/**
 * 添加更改单备注信息
 * @param data
 */
export function addOrderChangeRemark(data) {
  return request({
    url: 'api/addOrderChangeRemark',
    method: 'post',
    params: data
  })
}

/**
 * 获取更改单列表
 * @param data
 * @returns {AxiosPromise}
 */
export function getALLOrderChangeList(data) {
  return request({
    url: 'api/getALLOrderChangeList',
    method: 'post',
    params: data
  })
}

/**
 * 导出更改单列表
 * @param data
 * @returns {AxiosPromise}
 */
export function exportOrderChangeList(data) {
  return request({
    url: 'api/exportOrderChangeList',
    method: 'post',
    params: data
  })
}

/**
 * 更改单操作
 * @param data
 * @returns {AxiosPromise}
 */
export function operOrderChange(data) {
  return request({
    url: 'api/operOrderChange',
    method: 'post',
    params: data
  })
}

/**
 * 订单待报价导出Excel
 * @param data
 * @returns {AxiosPromise}
 */
export function exportOrderWaitOfferExcel(data) {
  return request({
    url: 'api/exportOrderWaitOfferExcel',
    method: 'post',
    params: data
  })
}

/**
 * 获取客供物料信息
 * @param data
 * @returns {AxiosPromise}
 */
export function selectClientOcm(data) {
  return request({
    url: 'api/selectClientOcm',
    method: 'post',
    params: data
  })
}
/**
 * 经销商用户填写客供物料物流信息
 * @param data
 * @returns {AxiosPromise}
 */
export function upClientOcm(data) {
  return request({
    url: 'api/upClientOcm',
    method: 'post',
    params: data
  })
}
/**
 * 经销商用户添加一个客供物料
 * @param data
 * @returns {AxiosPromise}
 */
export function addClientOcm(data) {
  return request({
    url: 'api/addClientOcm',
    method: 'post',
    params: data
  })
}

/**
 * 经销商用户删除一个客供物料
 * @param data
 * @returns {AxiosPromise}
 */
export function deleteClientOmc(data) {
  return request({
    url: 'api/deleteClientOmc',
    method: 'post',
    params: data
  })
}

/**
 * 员工用户查看客供物料详情
 * @param data
 * @returns {AxiosPromise}
 */
export function selectMaterialDetails(data) {
  return request({
    url: 'api/selectMaterialDetails',
    method: 'post',
    params: data
  })
}
/**
 * 员工用户确认收货
 * @param data
 * @returns {AxiosPromise}
 */
export function upReceiveTime(data) {
  return request({
    url: 'api/upReceiveTime',
    method: 'post',
    params: data
  })
}
/**
 * 订单生产报价计算
 * @param data
 * @returns {AxiosPromise}
 */
export function orderProductOfferOper(data) {
  return request({
    url: 'api/orderProductOfferOper',
    method: 'post',
    params: data
  })
}

/**
 * 修改订单生产折扣单项
 * @param data
 * @returns {AxiosPromise}
 */
export function editOrderProductOfferProdis(data) {
  return request({
    url: 'api/editOrderProductOfferProdis',
    method: 'post',
    params: data
  })
}
/**
 * 工厂接单查询PMC计划交期
 * @param data
 * @returns {AxiosPromise}
 */
export function selectPmcTimeList(data) {
  return request({
    url: 'api/selectPmcTimeList',
    method: 'post',
    params: data
  })
}
/**
 * 生产接单列表导出Excel
 * @param data
 * @returns {AxiosPromise}
 */
export function exportOrderProductList(data) {
  return request({
    url: 'api/exportOrderProductList',
    method: 'post',
    params: data
  })
}
/**
 * 订单排产列表导出Excel
 * @param data
 * @returns {AxiosPromise}
 */
export function exportOrderPlanProductList(data) {
  return request({
    url: 'api/exportOrderPlanProductList',
    method: 'post',
    params: data
  })
}
/**
 * 分类打印列表导出Excel
 * @param data
 * @returns {AxiosPromise}
 */
export function exportClassifyPrintList(data) {
  return request({
    url: 'api/exportClassifyPrintList',
    method: 'post',
    params: data
  })
}
/**
 * 分类打印列表导出Excel
 * @param data
 * @returns {AxiosPromise}
 */
export function exportPartsBarcodeList(data) {
  return request({
    url: 'api/exportPartsBarcodeList',
    method: 'post',
    params: data
  })
}
/**
 * 配件打印列表导出Excel
 * @param data
 * @returns {AxiosPromise}
 */
export function exportAccessoryPrintList(data) {
  return request({
    url: 'api/exportAccessoryPrintList',
    method: 'post',
    params: data
  })
}
/**
 * 木工全检列表导出Excel
 * @param data
 * @returns {AxiosPromise}
 */
export function exportWoodAllCheckList(data) {
  return request({
    url: 'api/exportWoodAllCheckList',
    method: 'post',
    params: data
  })
}
/**
 * 油漆全检列表导出Excel
 * @param data
 * @returns {AxiosPromise}
 */
export function exportPaintAllCheckList(data) {
  return request({
    url: 'api/exportPaintAllCheckList',
    method: 'post',
    params: data
  })
}
/**
 * 包装补打列表导出Excel
 * @param data
 * @returns {AxiosPromise}
 */
export function exportPackMendList(data) {
  return request({
    url: 'api/exportPackMendList',
    method: 'post',
    params: data
  })
}
/**
 * 打包列表导出Excel
 * @param data
 * @returns {AxiosPromise}
 */
export function exportPackingTableList(data) {
  return request({
    url: 'api/exportPackingTableList',
    method: 'post',
    params: data
  })
}
/**
 * 打包信息导出Excel
 * @param data
 * @returns {AxiosPromise}
 */
export function exportErpOrderPackInfoList(data) {
  return request({
    url: 'api/exportErpOrderPackInfoList',
    method: 'post',
    params: data
  })
}
/**
 * 库存管理导出Excel
 * @param data
 * @returns {AxiosPromise}
 */
export function exportStockControlList(data) {
  return request({
    url: 'api/exportStockControlList',
    method: 'post',
    params: data
  })
}
/**
 * 出库申请导出Excel
 * @param data
 * @returns {AxiosPromise}
 */
export function exportOutApplyList(data) {
  return request({
    url: 'api/exportOutApplyList',
    method: 'post',
    params: data
  })
}
/**
 * 出库导出Excel
 * @param data
 * @returns {AxiosPromise}
 */
export function exportOutDepotList(data) {
  return request({
    url: 'api/exportOutDepotList',
    method: 'post',
    params: data
  })
}
/**
 * 配件出库导出Excel
 * @param data
 * @returns {AxiosPromise}
 */
export function exportPartsOutList(data) {
  return request({
    url: 'api/exportPartsOutList',
    method: 'post',
    params: data
  })
}
/**
 * 原材料台账获取列表
 * @param data
 * @returns {AxiosPromise}
 */
export function getRawLedgerList(data) {
  return request({
    url: 'api/getRawLedgerList',
    method: 'post',
    params: data
  })
}
/**
 *获取所有mark>=13的订单
 * @param data
 * @returns {AxiosPromise}
 */
export function getOrderMarkList(data) {
  return request({
    url: 'api/getOrderMarkList',
    method: 'post',
    params: data
  })
}
/**
 *通过订单id获取订单详细信息
 * @param data
 * @returns {AxiosPromise}
 */
export function selectOrderidDetail(data) {
  return request({
    url: 'api/selectOrderidDetail',
    method: 'post',
    params: data
  })
}
/**
 *获取原材料类别字典表
 * @param data
 * @returns {AxiosPromise}
 */
export function getRawTypeAll() {
  return request({
    url: 'api/getRawTypeAll',
    method: 'post'
  })
}
/**
 *获取原材料不良类别字典表
 * @param data
 * @returns {AxiosPromise}
 */
export function geteRawBadtypeAll() {
  return request({
    url: 'api/geteRawBadtypeAll',
    method: 'post'
  })
}
/**
 *添加或修改原材料台账
 * @param data
 * @returns {AxiosPromise}
 */
export function updateAndaddRawLedger(data) {
  return request({
    url: 'api/updateAndaddRawLedger',
    method: 'post',
    params: data
  })
}
/**
 *原材料台账excel导出
 * @param data
 * @returns {AxiosPromise}
 */
export function exportRawLedgerList(data) {
  return request({
    url: 'api/exportRawLedgerList',
    method: 'post',
    params: data
  })
}
/**
 *获取质检记录列表
 * @param data
 * @returns {AxiosPromise}
 */
export function getQualityList(data) {
  return request({
    url: 'api/getQualityList',
    method: 'post',
    params: data
  })
}
/**
 *获取质检责任部门字典表
 * @param data
 * @returns {AxiosPromise}
 */
export function getQualityDeptAll() {
  return request({
    url: 'api/getQualityDeptAll',
    method: 'post'
  })
}
/**
 *获取质检责任部门下的不良类别
 * @param data
 * @returns {AxiosPromise}
 */
export function selectQualityBadList(data) {
  return request({
    url: 'api/selectQualityBadList',
    method: 'post',
    params: data
  })
}
/**
 *获取质检工序字典表
 * @param data
 * @returns {AxiosPromise}
 */
export function getQualityProcessAll(data) {
  return request({
    url: 'api/getQualityProcessAll',
    method: 'post'
  })
}
/**
 *添加或修改品质检验记录表
 * @param data
 * @returns {AxiosPromise}
 */
export function updateAndaddQuality(data) {
  return request({
    url: 'api/updateAndaddQuality',
    method: 'post',
    params: data
  })
}
/**
 *质检记录列表导出Excel
 * @param data
 * @returns {AxiosPromise}
 */
export function exportQualityList(data) {
  return request({
    url: 'api/exportQualityList',
    method: 'post',
    params: data
  })
}
/**
 *获取返工单责任工序字典表
 * @param data
 * @returns {AxiosPromise}
 */
export function getReworkProcessAll() {
  return request({
    url: 'api/getReworkProcessAll',
    method: 'post'
  })
}

/**
 *添加返工单
 * @param data
 * @returns {AxiosPromise}
 */
export function addReworkOrder(data) {
  return request({
    url: 'api/addReworkOrder',
    method: 'post',
    params: data
  })
}
/**
 *获取需要自己确认的返工单列表
 * @param data
 * @returns {AxiosPromise}
 */
export function getMyReworkOrderList(data) {
  return request({
    url: 'api/getMyReworkOrderList',
    method: 'post',
    params: data
  })
}
/**
 *直接责任人确认返回单
 * @param data
 * @returns {AxiosPromise}
 */
export function affirmReworkOrder(data) {
  return request({
    url: 'api/affirmReworkOrder',
    method: 'post',
    params: data
  })
}
/**
 *返工记录列表
 * @param data
 * @returns {AxiosPromise}
 */
export function getReworkOrderAll(data) {
  return request({
    url: 'api/getReworkOrderAll',
    method: 'post',
    params: data
  })
}
/**
 *返工单列表Excel导出
 * @param data
 * @returns {AxiosPromise}
 */
export function exportReworkOrderList(data) {
  return request({
    url: 'api/exportReworkOrderList',
    method: 'post',
    params: data
  })
}
/**
 *返工记录列表Excel导出
 * @param data
 * @returns {AxiosPromise}
 */
export function exportReworkOrderRecordList(data) {
  return request({
    url: 'api/exportReworkOrderRecordList',
    method: 'post',
    params: data
  })
}
/**
 *完工报告获取列表
 * @param data
 * @returns {AxiosPromise}
 */
export function selectFinishReport(data) {
  return request({
    url: 'api/selectFinishReport',
    method: 'post',
    params: data
  })
}
/**
 *完工报告Excel导出
 * @param data
 * @returns {AxiosPromise}
 */
export function exportFinishReportList(data) {
  return request({
    url: 'api/exportFinishReportList',
    method: 'post',
    params: data
  })
}
/**
 *品质图库添加图片
 * @param data
 * @returns {AxiosPromise}
 */
export function addImg(data) {
  return request({
    url: 'api/addImg',
    method: 'post',
    params: data
  })
}
/**
 *品质图库获取图片列表
 * @param data
 * @returns {AxiosPromise}
 */
export function selectQualityImgList(data) {
  return request({
    url: 'api/selectQualityImgList',
    method: 'post',
    params: data
  })
}
/**
 *品质图库获取图片列表
 * @param data
 * @returns {AxiosPromise}
 */
export function getPztkOrderList(data) {
  return request({
    url: 'api/getPztkOrderList',
    method: 'post',
    params: data
  })
}
/**
 *根据台账id获取此原材料台账不良类别
 * @param data
 * @returns {AxiosPromise}
 */
export function selectByRlidRawBadInfo(data) {
  return request({
    url: 'api/selectByRlidRawBadInfo',
    method: 'post',
    params: data
  })
}
/**
 *原材料分析获取数据
 * @param data
 * @returns {AxiosPromise}
 */
export function selectRawLedgerInfo(data) {
  return request({
    url: 'api/selectRawLedgerInfo',
    method: 'post',
    params: data
  })
}
/**
 *根据id删除原材料台账数据
 * @param data
 * @returns {AxiosPromise}
 */
export function deleteRawLedger(data) {
  return request({
    url: 'api/deleteRawLedger',
    method: 'post',
    params: data
  })
}
/**
 *根据id删除质检记录数据
 * @param data
 * @returns {AxiosPromise}
 */
export function deleteQuality(data) {
  return request({
    url: 'api/deleteQuality',
    method: 'post',
    params: data
  })
}
/**
 *根据返工单id删除返工单记录
 * @param data
 * @returns {AxiosPromise}
 */
export function deleteReworkOrder(data) {
  return request({
    url: 'api/deleteReworkOrder',
    method: 'post',
    params: data
  })
}
/**
 *根据品质图库图片id删除订单图片
 * @param data
 * @returns {AxiosPromise}
 */
export function deleteQualityImg(data) {
  return request({
    url: 'api/deleteQualityImg',
    method: 'post',
    params: data
  })
}

/**
 *获取质检处理措施字典表
 * @param data
 * @returns {AxiosPromise}
 */
export function getQualityMeasuresAll() {
  return request({
    url: 'api/getQualityMeasuresAll',
    method: 'post'
  })
}
/**
 *质检分析获取数据
 * @param data
 * @returns {AxiosPromise}
 */
export function selectQualityInfo(data) {
  return request({
    url: 'api/selectQualityInfo',
    method: 'post',
    params: data
  })
}
/**
 *质检分析获取根据生产单号划分的数据
 * @param data
 * @returns {AxiosPromise}
 */
export function selectProdunumQualityInfo(data) {
  return request({
    url: 'api/selectProdunumQualityInfo',
    method: 'post',
    params: data
  })
}
/**
 *质检分析获取根据周次划分的数据
 * @param data
 * @returns {AxiosPromise}
 */
export function selectMoneyInfo(data) {
  return request({
    url: 'api/selectMoneyInfo',
    method: 'post',
    params: data
  })
}
/**
 *根据订单id查询订单报价信息表
 * @param data
 * @returns {AxiosPromise}
 */
export function getOfferAmount(data) {
  return request({
    url: 'api/getOfferAmount',
    method: 'post',
    params: data
  })
}
/**
 *查询车间一次性合格率
 * @param data
 * @returns {AxiosPromise}
 */
export function selectPassQualityInfo(data) {
  return request({
    url: 'api/selectPassQualityInfo',
    method: 'post',
    params: data
  })
}

/**
 * 电子锯料单提取
 * @param data
 * @returns {AxiosPromise}
 */
export function electronicSawingListExt(data) {
  return request({
    url: 'api/electronicSawingListExt',
    method: 'post',
    params: data
  })
}

/**
 * 电子锯料单导出
 * @param data
 * @returns {AxiosPromise}
 */
export function ExcelElectronicSawingListExt(data) {
  return request({
    url: 'api/ExcelElectronicSawingListExt',
    method: 'post',
    params: data
  })
}
/**
 * 其他费用分析
 * @param data
 * @returns {AxiosPromise}
 */
export function getOrderOfferOtherAnalysis(data) {
  return request({
    url: 'api/getOrderOfferOtherAnalysis',
    method: 'post',
    params: data
  })
}
/**
 * 其他费用详情订单数据
 * @param data
 * @returns {AxiosPromise}
 */
export function getOfferOtherAnalysisOrderData(data) {
  return request({
    url: 'api/getOfferOtherAnalysisOrderData',
    method: 'post',
    params: data
  })
}
/**
 * 其他费用详情订单数据excel导出
 * @param data
 * @returns {AxiosPromise}
 */
export function exportOfferOtherAnalysisOrderExcel(data) {
  return request({
    url: 'api/exportOfferOtherAnalysisOrderExcel',
    method: 'post',
    params: data
  })
}

export function getOrderPartsBarcodePrintUrlNew(data) {
  return request({
    url: 'api/getOrderPartsBarcodePrintUrlNew',
    method: 'post',
    params: data
  })
}


/**
 * 订单采购列表
 * @param data
 */
export function getOrderProcureList(data) {
  return request({
    url: 'api/getOrderProcureList',
    method: 'post',
    params: data
  })
}

/**
 * 添加/编辑订单采购
 * @param data
 */
export function saveOrderProcure(data) {
  return request({
    url: 'api/saveOrderProcure',
    method: 'post',
    params: data
  })
}

/**
 * 删除订单采购
 * @param data
 */
export function deleteOrderProcure(data) {
  return request({
    url: 'api/deleteOrderProcure',
    method: 'post',
    params: data
  })
}

/**
 * 导出订单面积数据统计
 * @param data
 */
export function getTypeArea(data) {
  return request({
    url: 'api/getTypeArea',
    method: 'post',
    params: data
  })
}

/**
 * 订单全景
 * @param data
 */
export function getOrders(data) {
  return request({
    url: 'api/orders',
    method: 'post',
    params: data
  })
}


/**
 * 导出客供物料
 * @param {} data
 * @returns
 */
export function exportClientMaterials(data) {
  return request({
    url: 'api/exportClientMaterials',
    method: 'post',
    params: data
  })
}

/**
 * 客供物料列表
 * @param data
 */
export function getClientMaterials(data) {
  return request({
    url: 'api/getClientMaterials',
    method: 'post',
    params: data
  })
}
/**
 * 保存客供物料
 * @param data
 */
export function addorEditClientMaterial(data) {
  return request({
    url: 'api/addorEditClientMaterial',
    method: 'post',
    params: data
  })
}
/**
 * 删除客供物料
 * @param data
 */
export function delClientMaterial(data) {
  return request({
    url: 'api/delClientMaterial',
    method: 'post',
    params: data
  })
}
/**
 * 客供物料分类数据
 * @param data
 */
export function getClientMaterialData(data) {
  return request({
    url: 'api/getClientMaterialData',
    method: 'get',
    params: data
  })
}

/**
 * 获取客服列表
 * @param data
 */
export function getServers(data) {
  return request({
    url: 'api/getServers',
    method: 'post',
    params: data
  })
}

/**
 * 保存客供物料处理情况
 * @param data
 */
export function dealClientMaterial(data) {
  return request({
    url: 'api/dealClientMaterial',
    method: 'post',
    params: data
  })
}

/**
 * 获取暂存位置列表
 * @param data
 */
export function getStorages(data) {
  return request({
    url: 'api/getStorages',
    method: 'post',
    params: data
  })
}

/**
 * 获取归还方式列表
 * @param data
 */
export function getReturnType(data) {
  return request({
    url: 'api/getReturnType',
    method: 'post',
    params: data
  })
}
